import React, { useState } from "react";
import FormProgress from "../../../../common/FormProgress/FormProgress";
import { Button, Icon, Modal } from "antd";
import { getNumberWithoutSpaces } from "../../../../../../common/utils/format";
import showSuccessWindow from "../../../../../../common/components/successPopup/successPopup";
import BtnFormSubmit from "../buttons/BtnFormSubmit";
import { Skeleton } from "antd";
import RequestInfo from "../../common/sections/RequestInfo";

const OfferSideBar = props => {
  const [modalVisible, setVisible] = useState(false);

  // todo next release  const [docsDrawerVisible, setDocsDrawerVisible] = useState(false);
  function confirmAcceptOffer() {
    setVisible(false);
    showSuccessWindow({
      title: "Предложение открыто!",
      content: `Предложение номер ${getNumberWithoutSpaces(
        props.requestNumber
      )} заказчику ${props.customer} и доступно в личном кабинете!`,
      okText: "Готово",
      icon: <Icon type="check-circle" theme="filled" />,
      closable: false,
      maskClosable: true,
      centered: true,
      className: "employee-success-form"
    });
  }
  const { offer } = props;
  let timeInStops = 0;
  offer &&
    offer.routes &&
    offer.routes.forEach((item, index) => {
      let hours =
        (offer["routeDuration" + index] &&
          offer["routeDuration" + index].hours()) ||
        0;
      let minutes =
        (offer["routeDuration" + index] &&
          offer["routeDuration" + index].minutes()) ||
        0;
      timeInStops += hours * 60 + minutes;
    });

  const { request } = props;
  return (
    <>
      <div className="sidebar">
        <BtnFormSubmit
          disabled={props.disabled}
          onClick={props.handleSubmit}
          onClickTemplate={props.handleSubmitTemplate}
        />
        <div className="sidebar-info">
          <RequestInfo request={request} {...props} />
        </div>
        <div className="sidebar-info ymaps-info">
          <div className="line-content">
            {props.duration && props.distance && props.vehicleUse ? (
              <>
                <div className="line-content__row">
                  <div className="line-content__column">
                    <span
                      className="line-content__text"
                      style={{ width: "auto" }}
                    >
                      Время в пути (по&nbsp;картам)
                    </span>
                  </div>
                  <div className="line-content__column">
                    <span className="line-content__additional">
                      {props.vehicleUse}
                    </span>
                  </div>
                </div>
                <div className="line-content__row">
                  <div className="line-content__column">
                    <span
                      className="line-content__text"
                      style={{ width: "auto" }}
                    >
                      Длина маршрута (по&nbsp;картам)
                    </span>
                  </div>
                  <div className="line-content__column">
                    <span className="line-content__additional">
                      {props.distance}
                    </span>
                  </div>
                </div>
                <div className="line-content__row">
                  <div className="line-content__column">
                    <span
                      className="line-content__text"
                      style={{ width: "auto" }}
                    >
                      Время остановок
                    </span>
                  </div>
                  <div className="line-content__column">
                    <span className="line-content__additional">
                      {timeInStops ? `${timeInStops} мин` : "Без остановок"}
                    </span>
                  </div>
                </div>
                <div className="line-content__row">
                  <div className="line-content__column">
                    <span
                      className="line-content__text"
                      style={{ width: "auto" }}
                    >
                      Время исп. ТС
                    </span>
                  </div>
                  <div className="line-content__column">
                    <span className="line-content__additional">
                      {props.duration}
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <Skeleton active={true} />
            )}
          </div>
        </div>

        <div className="offer-card__progress">
          <FormProgress progress={props.progress} />
        </div>
        <Button
          ghost
          type="danger"
          htmlType="submit"
          size="large"
          className="offer-card-btn"
          onClick={() => props.handleCancel()}
        >
          Отмена
        </Button>
        <Modal
          visible={modalVisible}
          title={
            <div>
              <Icon style={{ color: "#323232" }} type="question-circle" />{" "}
              Внимание!
            </div>
          }
          onOk={() => {}}
          onCancel={() => {}}
          className="modal-template modal-open-offer"
          centered={true}
          footer={[
            <Button
              key="cancel"
              type="primary"
              ghost
              onClick={() => setVisible(false)}
            >
              Отмена
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={() => confirmAcceptOffer()}
            >
              Подтвердить
            </Button>
          ]}
        >
          Вы действительно хотите открыть предложение <br />{" "}
          {getNumberWithoutSpaces(props.requestNumber)} заказчику?
        </Modal>
      </div>
    </>
  );
};

export default OfferSideBar;
